import React, { useEffect, useState } from 'react';
import ResultDetails from './ResultDetails';
import { useParams } from 'react-router-dom';
import { authApiClient } from '../../services/api';

const ResultContainer = () => {
  const { id } = useParams();
  const [resultData, setResultData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchResultData = async () => {
      try {
        const response = await authApiClient.get(`submission/${id}/result/`);
        setResultData(response.data);
      } catch (err) {
        console.error('Error fetching result:', err);
        const msg = err.response?.data?.error || err.response?.data?.detail || 'خطا در دریافت اطلاعات';
        setError(msg);
      } finally {
        setLoading(false);
      }
    };

    fetchResultData();
  }, [id]);

  if (loading) return (
    <div className="flex items-center justify-center ">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
    </div>
  );
  
  if (error) return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-error bg-error p-4 rounded-lg">
        {error}
      </div>
    </div>
  );

  return (
    <div >
      <div className="container mx-auto my-5">
        <div className="flex flex-col md:flex-row theme-card max-w-4xl mx-auto overflow-hidden rounded-xl transition-shadow duration-300 hover:shadow-xl">
          <div className="relative w-full md:w-2/5">
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-black/10 z-10" />
            <img
              src="https://canvas-generations-v1.s3.us-west-2.amazonaws.com/fluxBanner3.webp"
              alt="تصویر نتیجه آزمون"
              className="w-full h-full object-cover"
              loading="lazy" 
            />
          </div>
          <div className="w-full md:w-3/5 p-6 md:p-8">
            {resultData && <ResultDetails resultData={resultData} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultContainer;